module.exports = __webpack_public_path__ + "img/posterSearch-des3.81541d82.png";